import { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

export const roadmapViewStyles = css`
  .item {
    margin: 1em;
    padding: 1em;
    background-color: #d7dce4;
    border-bottom: solid #b6b9d0 4px;
    color: #464141;
    opacity: 1;
    transition: opacity 400ms;

    &.faded {
      opacity: 0;
    }

    .svgIcon {
      float: right;
      margin-right: -8px;
      margin-top: -10px;
      margin-left: 8px;

      > div {
        > img {
          max-height: 18px;
          height: unset;
        }
      }
    }
  }
  .legend {
    vertical-align: top;
    padding: 1.2em 0;
    display: inline-block;

    .item {
      display: inline-block;
      clear: none;
      float: left;
      margin: 0 0.5em;
      padding: 0.3em 0.8em;

      .svgIcon {
        float: left;
        margin: 1px 8px 0 0;
        padding: 0;
      }

      .name {
        height: 18px;
        line-height: 18px;
      }
    }
  }
  table th {
    padding: 1em;
    font-size: 1.7em;
    font-weight: 500;
    text-align: center;
    min-width: 200px;
  }
  table thead > tr > th.header {
    border-right: solid ${colors.grey300} 1px;
  }
  table tr > th {
    color: #4f4e61;
    vertical-align: top;
  }

  table > tbody > tr {
    border-bottom: solid ${colors.grey300} 1px;
  }
  table > tbody > tr:last-child {
    border-bottom: none;
  }
  table tbody > tr > td {
    height: auto;
    font-size: 1.2em;
    border-right: solid ${colors.grey300} 1px;
    vertical-align: top;
  }
  table thead > tr > th:last-child,
  table tbody > tr > td:last-child {
    border-right: none;
  }
`;
